package kangaroorewards.appsdk.core.krMultiPartForm

import io.ktor.client.fetch.*
import org.khronos.webgl.ArrayBuffer
import org.khronos.webgl.Uint8Array
import org.khronos.webgl.get
import org.w3c.xhr.XMLHttpRequest
import org.w3c.xhr.XMLHttpRequestResponseType

actual class FileFromPath {
    actual fun get(path: String, callback: (ByteArray?) -> Unit) {
        console.log("[FileFromPath] get() called")
        console.log("[FileFromPath] path:", path)

        if (path.startsWith("blob:")) {
            console.log("[FileFromPath] detected blob URL -> using XHR")
            readBlobWithXhr(path, callback)
            return
        }

        console.log("[FileFromPath] using fetch() for non-blob path")
        fetch(path).then { response ->
            console.log(
                "[FileFromPath] fetch() response received:",
                "ok=${response.ok}, status=${response.status}"
            )

            if (!response.ok) {
                console.error("[FileFromPath] fetch response not ok -> callback(null)")
                callback(null)
                return@then
            }

            response.arrayBuffer().then { arrayBuffer ->
                console.log("[FileFromPath] fetch arrayBuffer() success")
                val bytes = arrayBufferToByteArray(arrayBuffer)
                console.log("[FileFromPath] converted fetch arrayBuffer to ByteArray, size=${bytes.size}")
                callback(bytes)
            }.catch { error ->
                console.error("[FileFromPath] fetch arrayBuffer() failed:", error)
                callback(null)
            }
        }.catch { error ->
            console.error("[FileFromPath] fetch() failed:", error)
            callback(null)
        }
    }

    private fun readBlobWithXhr(path: String, callback: (ByteArray?) -> Unit) {
        console.log("[FileFromPath] readBlobWithXhr() start")
        console.log("[FileFromPath] blob path:", path)

        try {
            val xhr = XMLHttpRequest()
            xhr.open("GET", path)
            xhr.asDynamic().responseType = "arraybuffer"

            xhr.onloadstart = {
                console.log("[FileFromPath] XHR onloadstart")
            }

            xhr.onprogress = { event ->
                console.log(
                    "[FileFromPath] XHR onprogress:",
                    "loaded=${event.loaded}, total=${event.total}"
                )
            }

            xhr.onload = {
                val status = xhr.status.toInt()
                console.log("[FileFromPath] XHR onload, status=$status")

                // Some browsers return 0 for blob/file URL success
                if (status == 200 || status == 0) {
                    val response = xhr.response
                    if (response != null) {
                        console.log("[FileFromPath] XHR response is not null, converting ArrayBuffer")
                        val bytes = arrayBufferToByteArray(response.unsafeCast<ArrayBuffer>())
                        console.log("[FileFromPath] XHR conversion success, size=${bytes.size}")
                        callback(bytes)
                    } else {
                        console.error("[FileFromPath] XHR response is null -> callback(null)")
                        callback(null)
                    }
                } else {
                    console.error("[FileFromPath] XHR non-success status=$status -> callback(null)")
                    callback(null)
                }
            }

            xhr.onerror = { event ->
                console.error("[FileFromPath] XHR onerror:", event)
                callback(null)
            }

            xhr.onabort = {
                console.error("[FileFromPath] XHR onabort -> callback(null)")
                callback(null)
            }

            xhr.ontimeout = {
                console.error("[FileFromPath] XHR ontimeout -> callback(null)")
                callback(null)
            }

            console.log("[FileFromPath] sending XHR request now")
            xhr.send()
        } catch (t: Throwable) {
            console.error("[FileFromPath] readBlobWithXhr() exception:", t.message)
            callback(null)
        }
    }

    private fun arrayBufferToByteArray(buffer: ArrayBuffer): ByteArray {
        console.log("[FileFromPath] arrayBufferToByteArray() start")
        val uint8Array = Uint8Array(buffer)
        console.log("[FileFromPath] Uint8Array length=${uint8Array.length}")

        val out = ByteArray(uint8Array.length) { i -> uint8Array[i].toByte() }
        console.log("[FileFromPath] arrayBufferToByteArray() done, output size=${out.size}")
        return out
    }
}